import { Category } from './types';

export const CATEGORIES: Category[] = [
  { id: "stem", label: "STEM Careers", description: "Science, engineering, tech, and math careers.", order: 1 },
  { id: "creative", label: "Creative Careers", description: "Design, media, animation, and creative tech.", order: 2 },
  { id: "health", label: "Health Careers", description: "Healthcare and wellbeing careers.", order: 3 },
  { id: "business", label: "Business Careers", description: "Leadership, marketing, policy, and impact.", order: 4 },
  { id: "digital", label: "Digital & Media", description: "Future jobs and digital careers.", order: 5 },
  { id: "trades", label: "Skilled Trades", description: "Hands-on skilled technical careers.", order: 6 },
];

export const PLACEHOLDER_IMAGES = {
  card: '/images/careers/_placeholders/fpt-placeholder-card.webp',
  thumb: '/images/careers/_placeholders/fpt-placeholder-thumb.webp',
  hero: '/images/careers/_placeholders/fpt-placeholder-card.webp',
  sidebar: '/images/careers/_placeholders/fpt-placeholder-card.webp'
};

export const SITE_URL = "https://futurepathteens.com";

/**
 * Normalizes a path to be an absolute public URL
 */
export const toPublicUrl = (p?: string) => {
  if (!p) return "";
  return p.startsWith("/") ? p : `/${p}`;
};
